import {Profile} from './profile.model';
import {ElementType} from '../ToolboxModel';
import {IRect} from '../../interfaces/IRect';
import {Common} from '../common';
import {v4 as uuidv4} from 'uuid';
import { BarProfile } from './bar.model';
import { LayerLevel } from '../../interfaces/LayerLevel';
import { LED_STRIP_MAX_LENGTH, SvgParams } from '../../constants/constants';

export class LedStripe extends Profile  {
	rect: IRect;

	get type(): ElementType {
		return ElementType.LedStripe;
	}

	get name(): string {
		return $localize`:Common|LED stripe:LED stripe`;
	}

	get layer(): LayerLevel {
		return LayerLevel.Middle;
	}

	public get bar() {
		return this._bar;
	} 

	public set bar(v: BarProfile) {
		this._bar = v;
		this.setRect();
	} 

	protected _optionName: string;
	get optionName(): string {
		return this._optionName;
	}

	constructor(
		_configId: string,
		private _bar: BarProfile,
		optionName: string,
		public channels: number
	) {
		super();
		this.id = this.type + "_" + uuidv4();
		this.color = 'yellow';
		this.configId = _configId;
		this._optionName = optionName;
		this.setRect();
	}

	private setRect() {
		const w = this._bar.rectOnRoof.w / 3;
		const x = this._bar.rectOnRoof.x + this._bar.rectOnRoof.w / 2 - w / 2;
		var y = Common.round(this._bar.rectOnRoof.y); 
		var h = this._bar.rectOnRoof.h;
		
		if (this.bar.length > LED_STRIP_MAX_LENGTH) {
			const diff = (this.bar.length - LED_STRIP_MAX_LENGTH) * SvgParams.SCALE / 2;
			y += diff;
			h  = LED_STRIP_MAX_LENGTH * SvgParams.SCALE;
		}

		this.rect = {
			x: Common.round(x),
			w: w,
			y: y,
			h: h
		};

		this.setLength(this._bar.getLength());
	}
}
